import { AfeTypeFields } from 'client/utils/AssetUtil';
import AFEOrderDetail from './AFEOrderDetail'

const AFEOrderDetailContainer = (props?: any) => {
  const {
    afeOrderByIdData
  } = props;

  return (
    <AFEOrderDetail
      afeOrderByIdData={afeOrderByIdData}
      fields={AfeTypeFields[afeOrderByIdData?.afeDetail?.afeType]}
    />
  )
}

export default AFEOrderDetailContainer